export default "__VITE_ASSET__b296789e__"